<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      visible
      width="800px"
      :close-on-click-modal="false"
      :before-close="() => $emit('colse')"
      append-to-body
    >
      <span slot="title" class="dialog-title">
        <span>{{
          $l('appraise_form_label_select_visit') || '选择拜访记录'
        }}</span>
        <el-button
          plain
          type="primary"
          size="small"
          class="mr-4"
          @click="directAdd()"
          >{{
            $l('appraise_form_label_add_directly_visit') || '无拜访记录直接新增'
          }}</el-button
        >
      </span>
      <vxe-grid
        auto-resize
        highlight-hover-row
        :data="tableData"
        :columns="tableColumns"
        :loading="loading"
        :height="300"
        size="small"
        resizable
        border
        :radio-config="{ highlight: true, trigger: 'row' }"
        @radio-change="radioChangeEvent"
      >
        <template v-slot:empty="{}">
          <div style="text-align: center">
            <img src="/image/static/img/nodata.png" />
            <p class="no-data">暂无数据！</p>
          </div>
        </template>
      </vxe-grid>
      <pagination
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        size="small"
        align="left"
        @change="handlePaginationChange"
        :layouts="['Total', 'Sizes', 'PrevPage', 'JumpNumber', 'NextPage']"
      />
      <span slot="footer">
        <el-button size="small" @click="() => $emit('colse')">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button type="primary" size="small" @click="confirm()">{{
          $l('INDEX.tips_confirm') || '确认'
        }}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      ref="scoreTemplateDialog"
      @opened="scoreTemplateDialogOpened"
      :title="$l('tips_choice_scoreTemplate') || '选择评分模板'"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="740px"
      append-to-body
    >
      <score-template
        ref="scoreTemplate"
        @success="choiceScoreTemplateSuccess"
        @cancel="choiceScoreTemplateCancel"
      ></score-template>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    scmCode: { type: String, default: '' },
    visible: { type: Boolean, default: false }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      page: {
        curPage: 1,
        pageSize: 5,
        pageTotal: 0
      },
      tableColumns: [
        {
          field: 'seq',
          width: 60,
          align: 'center',
          type: 'seq',
          fixed: 'left'
        },
        {
          width: 60,
          align: 'center',
          title: '选择',
          type: 'radio',
          fixed: 'left'
        },
        {
          field: 'visitDate',
          align: 'center',
          width: 120,
          title: this.$l('table_visit_label_visitDate') || '拜访日期'
        },
        {
          field: 'visitOwnerName',
          headerAlign: 'center',
          align: 'left',
          width: 150,
          title: this.$l('table_visit_label_visitOwnerName') || '拜访负责人'
        },
        {
          field: 'visitTitle',
          headerAlign: 'center',
          align: 'left',
          minWidth: 220,
          title: this.$l('visit_label_visitTitle') || '拜访目的'
        }
      ],
      selectVisitCode: '',
      dialogFormVisible: false
    }
  },
  components: {
    ScoreTemplate: () =>
      import(
        '@/views/digital/personal/myScmInfo/components/rating/scoreTemplate.vue'
      )
  },
  watch: {
    scmCode: {
      handler() {
        this.getData()
      },
      immediate: true
    }
  },
  methods: {
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total
      }
      this.$nextTick(() => {
        this.getData()
      })
    },
    getData() {
      if (!this.scmCode) return
      this.loading = true
      this.$api
        .scmInfoVisitListApi({ scmCode: this.scmCode, ...this.page })
        .then((res) => {
          this.loading = false
          this.page.pageTotal = res.body.count
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    radioChangeEvent({ row }) {
      this.selectVisitCode = row.visitCode
    },
    directAdd() {
      this.selectVisitCode = ''
      this.dialogFormVisible = true
    },
    confirm() {
      this.dialogFormVisible = true
    },
    scoreTemplateDialogOpened() {
      this.$refs.scoreTemplate.init()
    },
    choiceScoreTemplateSuccess(val) {
      let appraisalBillCode = val.appraisalBillCode

      if (this.selectVisitCode === '') {
        const params = {
          scmCode: this.scmCode,
          appraisalBillCode
        }
        this.$api.directSaveVisitScoreApi(params).then((res) => {
          this.selectVisitCode = res.body
          this.addVisitScore(appraisalBillCode)
        })
      } else {
        this.addVisitScore(appraisalBillCode)
      }
    },
    choiceScoreTemplateCancel() {
      this.dialogFormVisible = false
    },
    addVisitScore(appraisalBillCode) {
      let param = {
        scmCode: this.scmCode,
        visitCode: this.selectVisitCode,
        appraisalBillCode
      }
      this.$api.addVisitScoreApi(param).then((res) => {
        let visitScoreCode = res.body
        this.dialogFormVisible = false
        this.$emit('colse')
        this.$router.push({
          name: 'personal-myScmInfo-myVisit-rating-edit',
          params: {
            pageType: 'edit',
            visitScoreCode: visitScoreCode
          }
        })
      })
    }
  }
}
</script>
<style scoped>
.dialog-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
